/**
 * EmailSendService
 * Calls the server's /api/email/send endpoint which generates the PDF
 * and delivers it as an attachment via Gmail SMTP (Nodemailer).
 */
const EmailSendService = {
  /**
   * Send estimate or invoice PDF to customer email
   * @param {Object} data  - Same payload as PdfService (estimate/invoice data)
   * @param {string} toEmail - Customer's email address
   * @returns {Promise<boolean>}
   */
  async sendEmail(data, toEmail, { silent = false } = {}) {
    if (!toEmail || toEmail.trim() === '') {
      alert('Please enter a customer email address before sending.');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(toEmail.trim())) {
      alert('Please enter a valid email address.');
      return false;
    }

    try {
      const response = await fetch('/api/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ ...data, toEmail: toEmail.trim() }),
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.error || 'Failed to send email');
      }

      if (!silent) alert(`✅ Email sent successfully to ${toEmail}`);
      return true;
    } catch (error) {
      console.error('Email send error:', error);
      if (!silent) alert(`❌ Failed to send email: ${error.message}`);
      return false;
    }
  },
};

export default EmailSendService;
